export const roleList = [
  "Master Admin",
  "Admin",
  "Sub Admin",
  "Principal",
  "Front Office",
  "Student Information",
  "Fees Collection",
  "Expenses",
  "Examinations",
  "Human Resource",
  "Communicate",
  "Library",
  "Transport Management",
];

export const classList = [
  "Pratyush",
  "Arun",
  "Uday",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
];

export const sectionList = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "N",
  "Z",
];

export const categoryList = ["ST", "SC", "OBC", "General"];

export const houseList = [
  "Tejas - Orange",
  "Vayu - Yellow",
  "Prithvi - Green",
  "Apas - Blue",
  "None",
];

export const bloodGroupList = [
  "A+",
  "A-",
  "B+",
  "B-",
  "O+",
  "O-",
  "AB+",
  "AB-",
  "NA",
];
export const religionList = ["Hindu", "Muslim", "Sikh", "Chrisitan", "Jain"];

export const monthsList = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

export const paymentModes = [
  "Cash",
  "UPI",
  "NEFT",
  "Cheque",
  "Card Swap",
  "Net Banking",
];

export const miscellaneousType = [
  "ID Card",
  "Library",
  "Computer Lab",
  "Late Fee Payment",
  "Diary",
  "Damage Fine",
  "Uniform Violation",
  "Misbehavior",
  "Mobile Phone Violation",
  "Unauthorized Absence",
  "Sports Equipment Damage",
  "Transport Rule Violation",
  "Vandalism",
  "Exam Malpractice",
  "Class IX Registration Fee",
];

export const statesList = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Orissa",
  "Pondicherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Tripura",
  "Uttaranchal",
  "Uttar Pradesh",
  "West Bengal",
];

export const certificatesList = [
  "Birth Certificate",
  "Aadhar Card",
  "Apaar ID",
  "PEN",
  "Parent Aadhar Card",
  "Guardian Aadhar Card",
  "Emergency Person Aadhar Card",
  "Local Address Proof",
  "Medical Certificate",
  "Sibling ID Card (If studying in Acharyakulam)",
  "Photograph",
  "Caste Certificate",
  "Bank Details",
  "Transfer Certificate (TC) Original",
  "Report Card of Previous School",
];

export const relationshipsList = [
  "Guardian",
  "Grand Father",
  "Grand Mother",
  "Uncle",
  "Aunty",
  "Brother",
  "Sister",
  "Cousin",
  "Neighbor",
  "Teacher",
  "Other",
];

export const subjectList = [
  "Hindi",
  "Sanskrit",
  "English",
  "Maths",
  "Science",
  "Physics",
  "Chemistry",
  "Biology",
  "Social Science",
  "SST",
  "History",
  "Civics",
  "Geography",
  "Economics",
  "GK",
  "AI",
  "EVS",
  "Art",
  "Craft",
  "Dance",
  "Music",
  "Yog",
  "Oral",
  "Vedic Math",
  "Dictation",
  "Reading",
  "Writing",
  "Handwriting",
  "Rhymes",
  "Psychology",
  "Information Practice",
  "Physical Education",
  "Applied Maths",
  "Computer",
  "Business Studies",
  "Accountancy",
  "R1",
  "R2",
  "R3",
  "IT",
  "Hindi (R1)",
  "Hindi (R3)",
  "Sanskrit (R1)",
  "Sanskrit (R3)",
  "Hindi / Sanskrit (R1)",
  "Hindi / Sanskrit (R3)",
  "All Subject",
];

export const syllabusCategoryList = [
  "Weekly Test",
  "Monthly Test",
  "Cyclic Test",
  "Quarterly Examination",
  "Half-Yearly Examination",
  "Pre-Annual Examination",
  "Annual Examination",
  "Revision Test",
  "Mock Test",
  "Internal Assessment",
  "Class Test",
  "Surprise Test",
];

export const designationList = [
  "Co-Ordinator",
  "In-Charge",
  "English Teacher",
  "Hindi Teacher",
  "Mathematics Teacher",
  "Social Science Teacher",
  "Physics Teacher",
  "Chemistry Teacher",
  "Biology Teacher",
  "Science Teacher",
  "G.K Teacher",
  "EVS Teacher",
  "Sanskrit Teacher",
  "Computer Teacher",
  "Art Teacher",
  "Craft Teacher",
  "Music Teacher",
  "Dance Teacher",
  "Sports Teacher",
  "Yog Teacher",
  "Vedic Maths Teacher",
  "In-Charge (Pre-Primary)",
  "Mother Teacher",
  "Sports Teacher (Pre-Primary)",
  "Art Teacher (Pre-Primary)",
  "Yog Teacher (Pre-Primary)",
  "Dance Teacher (Pre-Primary)",
  "Principal",
  "Accounts Head",
  "Office Incharge",
  "Asst. Transport Incharge",
  "Office Assistant",
  "Transport Incharge",
  "IT Coordinator",
  "Facility Head",
  "Store Incharge",
  "Librarian",
  "Asst. Librarian",
  "Nurse",
  "Supervisor",
  "Electrician",
  "Driver",
  "Gardener",
  "Cook",
  "House Keeping",
  "NA",
];

export const departmentList = [
  "English (Co-Ordinator)",
  "English (In-Charge III - V)",
  "English",
  "Maths",
  "S.St/G.K",
  "S.St",
  "Physics",
  "Chemistry",
  "Biology",
  "Physics/Chemistry",
  "Chemistry/G.K",
  "EVS",
  "Computer",
  "Craft",
  "Music",
  "Vedic Maths",
  "In-Charge",
  "Pre-Primary",
  "Hindi",
  "Sanskrit",
  "Games",
  "Art",
  "Yog",
  "Dance",
  "Accounts",
  "Administration",
  "Transport",
  "Examination",
  "IT",
  "Library/Examination",
  "Library",
  "Non-Teaching",
];

export const basicQualificationList = [
  "Matriculation (10th)",
  "Secondary School Certificate (SSC)",
  "High School (10th)",
  "Higher Secondary Certificate (HSC)",
  "Intermediate (12th)",
  "Senior Secondary (12th)",
  "Pre-University Course (PUC)",
  "Diploma in Education (D.Ed)",
  "Diploma in Elementary Education (D.El.Ed)",
  "Junior Basic Training (JBT)",
  "Nursery Teachers Training (NTT)",
  "Primary Teachers Training (PTT)",
  "Diploma in Physical Education (D.P.Ed)",
  "Diploma in Art Education",
  "Diploma in Special Education",
  "Diploma in Early Childhood Education (ECCE)",
  "Bachelor of Arts (B.A)",
  "Bachelor of Science (B.Sc)",
  "Bachelor of Commerce (B.Com)",
  "Bachelor of Education (B.Ed)",
  "Bachelor of Elementary Education (B.El.Ed)",
  "Bachelor of Fine Arts (BFA)",
  "Bachelor of Physical Education (B.P.Ed)",
  "Bachelor of Social Work (BSW)",
  "Bachelor of Home Science (BHS)",
  "Bachelor of Library and Information Science",
  "Bachelor of Computer Applications (BCA)",
  "Bachelor of Science in Education (B.Sc.Ed)",
  "Integrated B.Sc-B.Ed",
  "Integrated B.A-B.Ed",
  "Bachelor of Engineering (B.E.)",
  "Bachelor of Technology (B.Tech)",
  "Shiksha Shastri",
  "Language Proficiency Certification",
  "Bridge Course in Elementary Education",
  "Certificate in Guidance",
  "Certificate in Counseling",
  "Montessori Teacher Training",
  "Waldorf Teacher Training",
  "Cambridge or IB Certified Teacher Training",
  "ITI Certificate",
  "Polytechnic Diploma",
  "Certificate in Art/Music/Dance",
  "Yoga Teacher Training Certificate",
  "B.A (English)",
  "B.A (Hindi)",
  "B.A (History)",
  "B.A (Geography)",
  "B.A (Political Science)",
  "B.A (Economics)",
  "B.A (Sociology)",
  "B.A (Psychology)",
  "NA",
];

export const masterQualificationList = [
  "Master of Arts (M.A)",
  "Master of Science (M.Sc)",
  "Master of Commerce (M.Com)",
  "Master of Computer Applications (MCA)",
  "Master of Education (M.Ed)",
  "Master of Physical Education (M.P.Ed)",
  "Master of Social Work (MSW)",
  "Master of Library and Information Science (MLIS)",
  "Master of Fine Arts (MFA)",
  "Master of Home Science (MHS)",
  "Master of Philosophy (M.Phil)",
  "Integrated M.Sc + B.Ed",
  "Integrated M.A + B.Ed",
  "M.Sc in Education",
  "M.A in Education",
  "M.Ed in Special Education",
  "M.Ed in Educational Technology",
  "M.Ed in Guidance and Counseling",
  "Master of Business Administration (MBA)",
  "M.A (English)",
  "M.A (Hindi)",
  "M.A (History)",
  "M.A (Geography)",
  "M.Sc (Mathematics)",
  "M.Sc (Physics)",
  "M.Sc (Chemistry)",
  "M.Sc (Biology)",
  "M.Sc (Environmental Science)",
  "M.A (Political Science)",
  "M.A (Economics)",
  "M.A (Sociology)",
  "M.A (Psychology)",
  "IB Professional Certification",
  "Montessori Advanced Diploma",
  "Waldorf Advanced Teacher Education",
  "NA",
];

export const professionalQualificationList = [
  "Bachelor of Education (B.Ed)",
  "Diploma in Elementary Education (D.El.Ed)",
  "Diploma in Education (D.Ed)",
  "Nursery Teacher Training (NTT)",
  "Primary Teacher Training (PTT)",
  "Basic Training Certificate (BTC)",
  "Junior Basic Training (JBT)",
  "Central Teacher Eligibility Test (CTET)",
  "State Teacher Eligibility Test (STET)",
  "Uttar Pradesh TET (UPTET)",
  "Maharashtra TET (MAHA TET)",
  "West Bengal TET (WB TET)",
  "Punjab State TET (PSTET)",
  "Andhra Pradesh TET (APTET)",
  "Karnataka TET (KTET)",
  "Tamil Nadu TET (TNTET)",
  "Delhi Teacher Eligibility Test (DTET)",
  "Diploma in Special Education",
  "B.Ed in Special Education",
  "Post Graduate Diploma in Special Education",
  "Certificate in Autism Spectrum Disorder Education",
  "Certificate in Learning Disabilities",
  "Certificate in Inclusive Education",
  "Montessori Training Certificate",
  "Waldorf Teacher Training",
  "CBSE Capacity Building Program Completion",
  "NIOS Training in Education",
  "NCERT Teacher Training Program",
  "ICT in Education Certification",
  "Digital Literacy Certification",
  "Educational Technology Integration Training",
  "Counseling and Guidance Certificate",
  "Life Skills Trainer Certification",
  "First Aid and Health Education Certification",
  "DIKSHA Online Course Certification",
  "NISHTHA Training Certification",
  "SWAYAM Training Program",
  "Samagra Shiksha Training Program",
  "NA",
];
